export function resolveRuntimeConfigPaths(_prefix: string): Record<string, string> {
  return {
    runtimeType: 'runtime.type',
    runtimeWorkload: 'runtime.workload',
    deployMode: '_inferencePdSeparation',
  };
}
